import { render, staticRenderFns } from "./BlockImageEvents.vue?vue&type=template&id=2d860fb4&"
import script from "./BlockImageEvents.vue?vue&type=script&lang=js&"
export * from "./BlockImageEvents.vue?vue&type=script&lang=js&"
import style0 from "./BlockImageEvents.vue?vue&type=style&index=0&id=2d860fb4&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports